var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRupinIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_282_9762)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.80922 14.669C4.60816 14.669 2.01318 12.0157 2.01318 8.7427C2.01318 5.4697 4.60816 2.81641 7.80922 2.81641C11.0103 2.81641 13.6052 5.4697 13.6052 8.7427C13.6052 12.0157 11.0103 14.669 7.80922 14.669Z",
    fill: "url(#paint0_linear_282_9762)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.20522 14.5205C5.00415 14.5205 2.40918 11.8673 2.40918 8.59426C2.40918 5.32126 5.00415 2.66797 8.20522 2.66797C11.4063 2.66797 14.0013 5.32126 14.0013 8.59426C14.0013 11.8673 11.4063 14.5205 8.20522 14.5205Z",
    fill: "#F2BC1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.20317 13.8666C5.35543 13.8666 3.04688 11.5062 3.04688 8.59444C3.04688 5.6827 5.35543 3.32227 8.20317 3.32227C11.0509 3.32227 13.3595 5.6827 13.3595 8.59444C13.3595 11.5062 11.0509 13.8666 8.20317 13.8666Z",
    fill: "url(#paint1_linear_282_9762)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.09974 3.43652C4.86243 3.9763 3.17627 6.00726 3.12591 8.46602C3.0662 11.3819 5.32967 13.7952 8.1815 13.8563C8.59811 13.8652 9.00379 13.8221 9.39379 13.7351C8.97782 13.8355 8.54286 13.8844 8.0958 13.8748C5.24398 13.8137 2.9805 11.4005 3.04022 8.48454C3.09123 5.99464 4.82018 3.94474 7.09974 3.43652Z",
    fill: "url(#paint2_linear_282_9762)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2028 8.83322C13.2625 5.91731 10.999 3.50397 8.14717 3.44295C6.97016 3.41775 5.87751 3.79794 4.99512 4.4573C5.90429 3.71946 7.06071 3.28883 8.31189 3.31563C11.1637 3.37669 13.4272 5.78999 13.3674 8.70591C13.3324 10.4184 12.5033 11.9225 11.2477 12.8608C12.4108 11.9168 13.1692 10.4699 13.2028 8.83322Z",
    fill: "url(#paint3_linear_282_9762)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.41025 12.1467C6.23957 12.1758 6.06415 12.1259 5.93009 12.0098C5.79583 11.894 5.71637 11.7233 5.71217 11.5433L5.68822 9.98449L4.43968 9.10283C4.25303 8.97101 4.15288 8.74141 4.18163 8.51039C4.21042 8.27963 4.36284 8.0875 4.57521 8.01518L5.99347 7.53124L6.39736 6.0364C6.45991 5.81486 6.63765 5.65017 6.85701 5.6106C7.07637 5.57104 7.3002 5.66328 7.43649 5.84896L8.33719 7.10848L9.83516 7.06639C10.0594 7.05995 10.2693 7.18672 10.377 7.39287C10.4846 7.59929 10.471 7.84941 10.3419 8.03819L9.48008 9.30051L10.0023 10.7694L10.0025 10.7693C10.0805 10.9894 10.0326 11.2343 9.87838 11.4016C9.7242 11.5688 9.49093 11.6293 9.27622 11.5575L7.84329 11.0784L6.66782 12.028C6.59287 12.0889 6.50452 12.1297 6.41025 12.1467Z",
    fill: "#F2BC1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.07968 12.0266C6.90901 12.0557 6.73358 12.0057 6.59953 11.8896C6.46526 11.7739 6.3858 11.6032 6.3816 11.4231L6.35765 9.86437L5.10911 8.98272C4.92246 8.85089 4.82231 8.62129 4.85106 8.39027C4.87986 8.15951 5.03227 7.96738 5.24464 7.89507L6.66291 7.41113L7.06679 5.91628C7.12934 5.69474 7.30709 5.53006 7.52644 5.49049C7.7458 5.45092 7.96963 5.54316 8.10593 5.72884L9.00663 6.98836L10.5046 6.94627C10.7288 6.93983 10.9388 7.0666 11.0464 7.27275C11.154 7.47917 11.1404 7.72929 11.0113 7.91807L10.1495 9.18039L10.6717 10.6493L10.672 10.6492C10.75 10.8692 10.702 11.1142 10.5478 11.2815C10.3936 11.4487 10.1604 11.5092 9.94565 11.4374L8.51272 10.9583L7.33725 11.9079C7.2623 11.9687 7.17396 12.0096 7.07968 12.0266Z",
    fill: "#FFFA59"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_282_9762",
    x1: 3.46529,
    y1: 11.5862,
    x2: 13.2311,
    y2: 5.19358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F49600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2444,
    stopColor: "#F8B220"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5286,
    stopColor: "#FCCD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7719,
    stopColor: "#FEDD50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9439,
    stopColor: "#FFE357"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_282_9762",
    x1: 3.34384,
    y1: 10.3637,
    x2: 13.0625,
    y2: 6.8252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F49600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1363,
    stopColor: "#F7A916"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3544,
    stopColor: "#FAC232"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5725,
    stopColor: "#FDD547"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7885,
    stopColor: "#FEDF53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE357"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_282_9762",
    x1: 3.33137,
    y1: 10.353,
    x2: 8.88219,
    y2: 8.33187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E55C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0853,
    stopColor: "#EA7100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1887,
    stopColor: "#EF8200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3176,
    stopColor: "#F28D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4983,
    stopColor: "#F49400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F49600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_282_9762",
    x1: 15.304,
    y1: 3.6585,
    x2: 7.42996,
    y2: 9.13081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3311,
    stopColor: "#F49600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3722,
    stopColor: "#F6A410"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#F9BB2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5511,
    stopColor: "#FCCD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6573,
    stopColor: "#FED94C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.786,
    stopColor: "#FFE154"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE357"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_282_9762"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.9874,
    height: 12.001,
    fill: "white",
    transform: "translate(2.01318 2.66699)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRupinIcons);
export default __webpack_public_path__ + "static/media/Rupin Icons.7cecc2f95e622920b96af32823deeadd.svg";
export { ForwardRef as ReactComponent };